export enum LinkTypeStatsClick {
	// CARD MAIN PAGE - Social Links & Contact
	SAVE_CONTACT = 'SAVE_CONTACT',
	WHATSAPP = 'WHATSAPP',
	FACEBOOK = 'FACEBOOK',
	LINKEDIN = 'LINKEDIN',
	YOUTUBE = 'YOUTUBE',
	EMAIL = 'EMAIL',
	PHONE_NUMBER = 'PHONE_NUMBER',
	INSTAGRAM = 'INSTAGRAM',
	TWITTER = 'TWITTER',
	TIKTOK = 'TIKTOK',
	YELP = 'YELP',
	MAPS = 'MAPS',
	WEBSITE = 'WEBSITE',

	// CARD MAIN PAGE - Branding & UI
	LOGO = 'LOGO',
	SECONDARY_LOGO = 'SECONDARY_LOGO',
	MBC_ELEMENT = 'MBC_ELEMENT',

	// CARD MAIN PAGE - Sharing Actions
	CARD_SHARE_BUTTON = 'CARD_SHARE_BUTTON',
	CARD_SHARE_WHATSAPP = 'CARD_SHARE_WHATSAPP',
	CARD_SHARE_FACEBOOK = 'CARD_SHARE_FACEBOOK',
	CARD_SHARE_INSTAGRAM = 'CARD_SHARE_INSTAGRAM',
	CARD_SHARE_TELEGRAM = 'CARD_SHARE_TELEGRAM',
	CARD_SHARE_LINKEDIN = 'CARD_SHARE_LINKEDIN',
	CARD_SHARE_TWITTER = 'CARD_SHARE_TWITTER',
	CARD_SHARE_TIKTOK = 'CARD_SHARE_TIKTOK',
	CARD_SHARE_COPY_URL = 'CARD_SHARE_COPY_URL',

	// PROMOTED CONTENT - Images
	PROMOTED_BANNER_IMAGE = 'PROMOTED_BANNER_IMAGE',
	PROMOTED_CAROUSEL_IMAGE = 'PROMOTED_CAROUSEL_IMAGE',
	PROMOTED_CAROUSEL_ARROW_LEFT = 'PROMOTED_CAROUSEL_ARROW_LEFT',
	PROMOTED_CAROUSEL_ARROW_RIGHT = 'PROMOTED_CAROUSEL_ARROW_RIGHT',
	PROMOTED_CAROUSEL_DOT = 'PROMOTED_CAROUSEL_DOT',
	PROMOTED_IMAGE_GRID = 'PROMOTED_IMAGE_GRID',

	// PROMOTED CONTENT - Videos
	PROMOTED_YOUTUBE_VIDEO_PLAY = 'PROMOTED_YOUTUBE_VIDEO_PLAY',
	PROMOTED_YOUTUBE_VIDEO_PAUSE = 'PROMOTED_YOUTUBE_VIDEO_PAUSE',
	PROMOTED_YOUTUBE_VIDEO_ENDED = 'PROMOTED_YOUTUBE_VIDEO_ENDED',
	PROMOTED_YOUTUBE_LIST_VIDEO_PLAY = 'PROMOTED_YOUTUBE_LIST_VIDEO_PLAY',
	PROMOTED_HOSTED_VIDEO_PLAY = 'PROMOTED_HOSTED_VIDEO_PLAY',
	PROMOTED_HOSTED_VIDEO_PAUSE = 'PROMOTED_HOSTED_VIDEO_PAUSE',
	PROMOTED_HOSTED_VIDEO_ENDED = 'PROMOTED_HOSTED_VIDEO_ENDED',

	// PROMOTED CONTENT - Real Estate
	PROMOTED_REAL_ESTATE_LISTING = 'PROMOTED_REAL_ESTATE_LISTING',
	PROMOTED_SEARCH_WIDGET_SUBMIT = 'PROMOTED_SEARCH_WIDGET_SUBMIT',

	// PROPERTY DETAIL PAGE - Navigation
	PROPERTY_FOOTER_POWERED_BY = 'PROPERTY_FOOTER_POWERED_BY',

	// PROPERTY DETAIL PAGE - Photos & Gallery
	PROPERTY_PHOTO_GALLERY_OPEN = 'PROPERTY_PHOTO_GALLERY_OPEN',
	PROPERTY_GALLERY_ARROW_LEFT = 'PROPERTY_GALLERY_ARROW_LEFT',
	PROPERTY_GALLERY_ARROW_RIGHT = 'PROPERTY_GALLERY_ARROW_RIGHT',
	PROPERTY_PHOTO_360_TOUR = 'PROPERTY_PHOTO_360_TOUR',
	PROPERTY_PHOTO_SHARE_BUTTON = 'PROPERTY_PHOTO_SHARE_BUTTON',
	PROPERTY_PHOTO_SHARE_WHATSAPP = 'PROPERTY_PHOTO_SHARE_WHATSAPP',
	PROPERTY_PHOTO_SHARE_FACEBOOK = 'PROPERTY_PHOTO_SHARE_FACEBOOK',
	PROPERTY_PHOTO_SHARE_INSTAGRAM = 'PROPERTY_PHOTO_SHARE_INSTAGRAM',
	PROPERTY_PHOTO_SHARE_TELEGRAM = 'PROPERTY_PHOTO_SHARE_TELEGRAM',
	PROPERTY_PHOTO_SHARE_LINKEDIN = 'PROPERTY_PHOTO_SHARE_LINKEDIN',
	PROPERTY_PHOTO_SHARE_TWITTER = 'PROPERTY_PHOTO_SHARE_TWITTER',
	PROPERTY_PHOTO_SHARE_TIKTOK = 'PROPERTY_PHOTO_SHARE_TIKTOK',
	PROPERTY_PHOTO_COPY_URL = 'PROPERTY_PHOTO_COPY_URL',

	// PROPERTY DETAIL PAGE - Content Interactions
	PROPERTY_DESCRIPTION_READ_MORE = 'PROPERTY_DESCRIPTION_READ_MORE',
	PROPERTY_MAP_INTERACTION = 'PROPERTY_MAP_INTERACTION',
	PROPERTY_FEATURES_ACCORDION_TOGGLE = 'PROPERTY_FEATURES_ACCORDION_TOGGLE',

	// PROPERTY DETAIL PAGE - Contact Form
	PROPERTY_CONTACT_FORM_TOGGLE = 'PROPERTY_CONTACT_FORM_TOGGLE',
	PROPERTY_CONTACT_FORM_SUBMIT = 'PROPERTY_CONTACT_FORM_SUBMIT',
	PROPERTY_CONTACT_TERMS_LINK = 'PROPERTY_CONTACT_TERMS_LINK',

	// SEARCH PAGE - Navigation
	SEARCH_FOOTER_POWERED_BY = 'SEARCH_FOOTER_POWERED_BY',

	// SEARCH PAGE - Filters
	SEARCH_FILTER_TOGGLE_MOBILE = 'SEARCH_FILTER_TOGGLE_MOBILE',
	SEARCH_FILTER_LOCATION_CHANGE = 'SEARCH_FILTER_LOCATION_CHANGE',
	SEARCH_FILTER_RADIUS_CHANGE = 'SEARCH_FILTER_RADIUS_CHANGE',
	SEARCH_FILTER_TYPE_COMMERCIAL = 'SEARCH_FILTER_TYPE_COMMERCIAL',
	SEARCH_FILTER_TYPE_RESIDENTIAL = 'SEARCH_FILTER_TYPE_RESIDENTIAL',
	SEARCH_FILTER_TYPE_LAND = 'SEARCH_FILTER_TYPE_LAND',
	SEARCH_FILTER_SUBTYPE_CHANGE = 'SEARCH_FILTER_SUBTYPE_CHANGE',
	SEARCH_FILTER_PRICE_MIN_CHANGE = 'SEARCH_FILTER_PRICE_MIN_CHANGE',
	SEARCH_FILTER_PRICE_MAX_CHANGE = 'SEARCH_FILTER_PRICE_MAX_CHANGE',
	SEARCH_FILTER_BEDROOMS_CHANGE = 'SEARCH_FILTER_BEDROOMS_CHANGE',
	SEARCH_FILTER_BATHROOMS_CHANGE = 'SEARCH_FILTER_BATHROOMS_CHANGE',
	SEARCH_FILTER_SUBMIT = 'SEARCH_FILTER_SUBMIT',
	SEARCH_FILTER_CLEAR_ALL = 'SEARCH_FILTER_CLEAR_ALL',

	// SEARCH PAGE - Map Interactions
	SEARCH_MAP_MARKER_CLICK = 'SEARCH_MAP_MARKER_CLICK',
	SEARCH_MAP_INFO_WINDOW_CLICK = 'SEARCH_MAP_INFO_WINDOW_CLICK',

	// SEARCH PAGE - Results
	SEARCH_LOAD_MORE = 'SEARCH_LOAD_MORE',

	// SHOWCASE PAGE - Navigation
	SHOWCASE_FOOTER_POWERED_BY = 'SHOWCASE_FOOTER_POWERED_BY',

	// SHOWCASE PAGE - Contact & Social
	SHOWCASE_WHATSAPP_BUTTON = 'SHOWCASE_WHATSAPP_BUTTON',
	SHOWCASE_SOCIAL_EMAIL = 'SHOWCASE_SOCIAL_EMAIL',
	SHOWCASE_SOCIAL_FACEBOOK = 'SHOWCASE_SOCIAL_FACEBOOK',
	SHOWCASE_SOCIAL_INSTAGRAM = 'SHOWCASE_SOCIAL_INSTAGRAM',
	SHOWCASE_SOCIAL_TWITTER = 'SHOWCASE_SOCIAL_TWITTER',
	SHOWCASE_SOCIAL_TIKTOK = 'SHOWCASE_SOCIAL_TIKTOK',
	SHOWCASE_SOCIAL_YELP = 'SHOWCASE_SOCIAL_YELP',
	SHOWCASE_SOCIAL_MAPS = 'SHOWCASE_SOCIAL_MAPS',
	SHOWCASE_SOCIAL_WEBSITE = 'SHOWCASE_SOCIAL_WEBSITE',
	SHOWCASE_SOCIAL_TELEGRAM = 'SHOWCASE_SOCIAL_TELEGRAM',
	SHOWCASE_SOCIAL_LINKEDIN = 'SHOWCASE_SOCIAL_LINKEDIN',
	SHOWCASE_SOCIAL_YOUTUBE = 'SHOWCASE_SOCIAL_YOUTUBE'
}

export const LinkTypeStatsClickLabelMap: Record<LinkTypeStatsClick, string> = {
	[LinkTypeStatsClick.SAVE_CONTACT]: 'Save contact',
	[LinkTypeStatsClick.WHATSAPP]: 'WhatsApp',
	[LinkTypeStatsClick.FACEBOOK]: 'Facebook',
	[LinkTypeStatsClick.LINKEDIN]: 'LinkedIn',
	[LinkTypeStatsClick.YOUTUBE]: 'YouTube',
	[LinkTypeStatsClick.EMAIL]: 'Email',
	[LinkTypeStatsClick.PHONE_NUMBER]: 'Phone number',
	[LinkTypeStatsClick.INSTAGRAM]: 'Instagram',
	[LinkTypeStatsClick.TWITTER]: 'Twitter',
	[LinkTypeStatsClick.TIKTOK]: 'TikTok',
	[LinkTypeStatsClick.YELP]: 'Yelp',
	[LinkTypeStatsClick.MAPS]: 'Maps',
	[LinkTypeStatsClick.WEBSITE]: 'Website',

	[LinkTypeStatsClick.LOGO]: 'Logo',
	[LinkTypeStatsClick.SECONDARY_LOGO]: 'Secondary logo',
	[LinkTypeStatsClick.MBC_ELEMENT]: 'MBC element',

	[LinkTypeStatsClick.CARD_SHARE_BUTTON]: 'Card share button',
	[LinkTypeStatsClick.CARD_SHARE_WHATSAPP]: 'Share on WhatsApp',
	[LinkTypeStatsClick.CARD_SHARE_FACEBOOK]: 'Share on Facebook',
	[LinkTypeStatsClick.CARD_SHARE_INSTAGRAM]: 'Share on Instagram',
	[LinkTypeStatsClick.CARD_SHARE_TELEGRAM]: 'Share on Telegram',
	[LinkTypeStatsClick.CARD_SHARE_LINKEDIN]: 'Share on LinkedIn',
	[LinkTypeStatsClick.CARD_SHARE_TWITTER]: 'Share on Twitter',
	[LinkTypeStatsClick.CARD_SHARE_TIKTOK]: 'Share on TikTok',
	[LinkTypeStatsClick.CARD_SHARE_COPY_URL]: 'Copy share URL',

	[LinkTypeStatsClick.PROMOTED_BANNER_IMAGE]: 'Promoted banner image',
	[LinkTypeStatsClick.PROMOTED_CAROUSEL_IMAGE]: 'Promoted carousel image',
	[LinkTypeStatsClick.PROMOTED_CAROUSEL_ARROW_LEFT]: 'Promoted carousel arrow left',
	[LinkTypeStatsClick.PROMOTED_CAROUSEL_ARROW_RIGHT]: 'Promoted carousel arrow right',
	[LinkTypeStatsClick.PROMOTED_CAROUSEL_DOT]: 'Promoted carousel dot',
	[LinkTypeStatsClick.PROMOTED_IMAGE_GRID]: 'Promoted image grid',

	[LinkTypeStatsClick.PROMOTED_YOUTUBE_VIDEO_PLAY]: 'Play promoted YouTube video',
	[LinkTypeStatsClick.PROMOTED_YOUTUBE_VIDEO_PAUSE]: 'Pause promoted YouTube video',
	[LinkTypeStatsClick.PROMOTED_YOUTUBE_VIDEO_ENDED]: 'Promoted YouTube video ended',
	[LinkTypeStatsClick.PROMOTED_YOUTUBE_LIST_VIDEO_PLAY]: 'Play promoted YouTube list video',
	[LinkTypeStatsClick.PROMOTED_HOSTED_VIDEO_PLAY]: 'Play promoted hosted video',
	[LinkTypeStatsClick.PROMOTED_HOSTED_VIDEO_PAUSE]: 'Pause promoted hosted video',
	[LinkTypeStatsClick.PROMOTED_HOSTED_VIDEO_ENDED]: 'Promoted hosted video ended',

	[LinkTypeStatsClick.PROMOTED_REAL_ESTATE_LISTING]: 'Promoted real estate listing',
	[LinkTypeStatsClick.PROMOTED_SEARCH_WIDGET_SUBMIT]: 'Promoted search widget submit',

	[LinkTypeStatsClick.PROPERTY_FOOTER_POWERED_BY]: 'Property footer powered by',

	[LinkTypeStatsClick.PROPERTY_PHOTO_GALLERY_OPEN]: 'Open property photo gallery',
	[LinkTypeStatsClick.PROPERTY_GALLERY_ARROW_LEFT]: 'Property gallery arrow left',
	[LinkTypeStatsClick.PROPERTY_GALLERY_ARROW_RIGHT]: 'Property gallery arrow right',
	[LinkTypeStatsClick.PROPERTY_PHOTO_360_TOUR]: 'Property 360° tour',
	[LinkTypeStatsClick.PROPERTY_PHOTO_SHARE_BUTTON]: 'Property photo share button',
	[LinkTypeStatsClick.PROPERTY_PHOTO_SHARE_WHATSAPP]: 'Share property photo on WhatsApp',
	[LinkTypeStatsClick.PROPERTY_PHOTO_SHARE_FACEBOOK]: 'Share property photo on Facebook',
	[LinkTypeStatsClick.PROPERTY_PHOTO_SHARE_INSTAGRAM]: 'Share property photo on Instagram',
	[LinkTypeStatsClick.PROPERTY_PHOTO_SHARE_TELEGRAM]: 'Share property photo on Telegram',
	[LinkTypeStatsClick.PROPERTY_PHOTO_SHARE_LINKEDIN]: 'Share property photo on LinkedIn',
	[LinkTypeStatsClick.PROPERTY_PHOTO_SHARE_TWITTER]: 'Share property photo on Twitter',
	[LinkTypeStatsClick.PROPERTY_PHOTO_SHARE_TIKTOK]: 'Share property photo on TikTok',
	[LinkTypeStatsClick.PROPERTY_PHOTO_COPY_URL]: 'Copy property photo URL',

	[LinkTypeStatsClick.PROPERTY_DESCRIPTION_READ_MORE]: 'Read more property description',
	[LinkTypeStatsClick.PROPERTY_MAP_INTERACTION]: 'Property map interaction',
	[LinkTypeStatsClick.PROPERTY_FEATURES_ACCORDION_TOGGLE]: 'Toggle property features',

	[LinkTypeStatsClick.PROPERTY_CONTACT_FORM_TOGGLE]: 'Toggle property contact form',
	[LinkTypeStatsClick.PROPERTY_CONTACT_FORM_SUBMIT]: 'Submit property contact form',
	[LinkTypeStatsClick.PROPERTY_CONTACT_TERMS_LINK]: 'Property contact terms link',

	[LinkTypeStatsClick.SEARCH_FOOTER_POWERED_BY]: 'Search footer powered by',

	[LinkTypeStatsClick.SEARCH_FILTER_TOGGLE_MOBILE]: 'Toggle search filters (mobile)',
	[LinkTypeStatsClick.SEARCH_FILTER_LOCATION_CHANGE]: 'Change search location',
	[LinkTypeStatsClick.SEARCH_FILTER_RADIUS_CHANGE]: 'Change search radius',
	[LinkTypeStatsClick.SEARCH_FILTER_TYPE_COMMERCIAL]: 'Filter: commercial',
	[LinkTypeStatsClick.SEARCH_FILTER_TYPE_RESIDENTIAL]: 'Filter: residential',
	[LinkTypeStatsClick.SEARCH_FILTER_TYPE_LAND]: 'Filter: land',
	[LinkTypeStatsClick.SEARCH_FILTER_SUBTYPE_CHANGE]: 'Change search subtype',
	[LinkTypeStatsClick.SEARCH_FILTER_PRICE_MIN_CHANGE]: 'Change minimum price filter',
	[LinkTypeStatsClick.SEARCH_FILTER_PRICE_MAX_CHANGE]: 'Change maximum price filter',
	[LinkTypeStatsClick.SEARCH_FILTER_BEDROOMS_CHANGE]: 'Change bedrooms filter',
	[LinkTypeStatsClick.SEARCH_FILTER_BATHROOMS_CHANGE]: 'Change bathrooms filter',
	[LinkTypeStatsClick.SEARCH_FILTER_SUBMIT]: 'Submit search filters',
	[LinkTypeStatsClick.SEARCH_FILTER_CLEAR_ALL]: 'Clear all search filters',

	[LinkTypeStatsClick.SEARCH_MAP_MARKER_CLICK]: 'Click search map marker',
	[LinkTypeStatsClick.SEARCH_MAP_INFO_WINDOW_CLICK]: 'Click search map info window',

	[LinkTypeStatsClick.SEARCH_LOAD_MORE]: 'Load more search results',

	[LinkTypeStatsClick.SHOWCASE_FOOTER_POWERED_BY]: 'Showcase footer powered by',

	[LinkTypeStatsClick.SHOWCASE_WHATSAPP_BUTTON]: 'Showcase WhatsApp button',
	[LinkTypeStatsClick.SHOWCASE_SOCIAL_EMAIL]: 'Showcase social email',
	[LinkTypeStatsClick.SHOWCASE_SOCIAL_FACEBOOK]: 'Showcase Facebook',
	[LinkTypeStatsClick.SHOWCASE_SOCIAL_INSTAGRAM]: 'Showcase Instagram',
	[LinkTypeStatsClick.SHOWCASE_SOCIAL_TWITTER]: 'Showcase Twitter',
	[LinkTypeStatsClick.SHOWCASE_SOCIAL_TIKTOK]: 'Showcase TikTok',
	[LinkTypeStatsClick.SHOWCASE_SOCIAL_YELP]: 'Showcase Yelp',
	[LinkTypeStatsClick.SHOWCASE_SOCIAL_MAPS]: 'Showcase Maps',
	[LinkTypeStatsClick.SHOWCASE_SOCIAL_WEBSITE]: 'Showcase Website',
	[LinkTypeStatsClick.SHOWCASE_SOCIAL_TELEGRAM]: 'Showcase Telegram',
	[LinkTypeStatsClick.SHOWCASE_SOCIAL_LINKEDIN]: 'Showcase LinkedIn',
	[LinkTypeStatsClick.SHOWCASE_SOCIAL_YOUTUBE]: 'Showcase YouTube'
};
